module.exports = __webpack_public_path__ + "img/altima.8b9f6bc4.png";